<template>
  <v-app-bar app color="#fff">
    <v-app-bar-nav-icon @click="activeDrawer"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
    <p class="ma-0 mr-4">Usuário: {{ userName | pascalCase}}</p>
    <p class="ma-0">Papel: {{ role | pascalCase }}</p>
  </v-app-bar>
</template>
<script>
import formatName from '@/mixins/formatName';
export default {

  mixins: [formatName],

  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    drawerData: true,
    userName: null,
    role: null,
  }),

  watch: {
    drawer(value) {
      this.drawerData = value;
    },
  },

  methods: {
    activeDrawer() {
      this.drawerData = !this.drawerData;
      this.$emit("setDrawer", this.drawerData);
    },
  },

  created() {
    this.userName = this.$keycloak.tokenParsed.given_name;
    this.role = this.$keycloak.tokenParsed.resource_access["painel-administrativo-rpa-v2"]?.roles[0];
  },
  
};
</script>
